<template lang="">
<!-- 모달 영역 -->
<div class="modal_wrap" v-if="isAnyModalOpen">
    <!-- 로그인 모달 -->
    <LoginModal v-if="modals.loginModal" @close="closeModal('loginModal')" />
    <!-- 비회원 모달 -->
    <NonMemberModal v-if="modals.nonMemberModal" @close="closeModal('nonMemberModal')"/>
    <!-- 아이디 찾기/비밀번호 재설정 모달 -->
    <FindIdPasswordModal v-if="modals.findIdPasswordModal" @close="closeModal('findIdPasswordModal')"/>
    <!-- 간편로그인 미 연결 모달 -->
    <SnsConnectModal v-if="modals.snsConnectModal" @close="closeModal('snsConnectModal')"/>
    <!-- 얼럿 -->
    <AlertModal v-if="modals.alertModal" :message=modalData.message @close="closeModal('alertModal')"/>
    <!-- 회원탈퇴 팝업 -->
    <SignoutModal v-if="modals.signoutModal" @close="closeModal('signoutModal')"/>
    <!-- 기부영수증 팝업 -->
    <DonationReceiptModal v-if="modals.donationReceiptModal" @close="closeModal('donationReceiptModal')"/>
    <!-- 현금영수증 수정 팝업 -->
    <CashReceiptEditModal v-if="modals.cashReceiptEditModal" @close="closeModal('cashReceiptEditModal')"/>
    <!-- 후기 작성 팝업 -->
    <CreateReviewModal v-if="modals.createReviewModal" @close="closeModal('createReviewModal')"/>
    <!-- 컨펌 얼럿 -->
    <ConfirmModal v-if="modals.confirmModal" :message=modalData.message @confirm="handleConfirm" @close="handleClose('confirmModal')"/>
    <!-- 결제 정보 입력 모달 -->
    <PaymentModal v-if="modals.paymentModal" @close="closeModal('paymentModal')" :modalData=modalData />
    <!-- 조의금 안내 모달 -->
    <MournerBankModal v-if="modals.mournerBankModal" @close="closeModal('mournerBankModal')" :modalData=modalData />

</div>
<!-- //모달 영역 -->
</template>

<script>
import LoginModal from './modals/LoginModal.vue';
import AlertModal from './modals/AlertModal.vue';
import NonMemberModal from './modals/NonMemberModal.vue';
import FindIdPasswordModal from './modals/FindIdPasswordModal.vue';
import SnsConnectModal from './modals/SnsConnectModal.vue';
import SignoutModal from './modals/SignoutModal.vue';
import DonationReceiptModal from './modals/DonationReceiptModal.vue';
import CashReceiptEditModal from './modals/CashReceiptEditModal.vue';
import CreateReviewModal from './modals/CreateReviewModal.vue';
import ConfirmModal from './modals/ConfirmModal.vue';
import PaymentModal from './modals/PaymentModal.vue';
import MournerBankModal from './modals/MournerBankModal.vue';

export default {
    components: {
        LoginModal,
        AlertModal,
        NonMemberModal,
        FindIdPasswordModal,
        SnsConnectModal,
        SignoutModal,
        DonationReceiptModal,
        CashReceiptEditModal,
        CreateReviewModal,
        ConfirmModal,
        PaymentModal,
        MournerBankModal
    },

    data() {
        return {
            modals: {
                loginModal: false,              // 로그인 모달
                nonMemberModal: false,          // 비회원 모달
                findIdPasswordModal: false,     // 아이디 찾기/비밀번호 재설정 모달
                snsConnectModal: false,         // 간편로그인 미 연결 모달
                alertModal: false,              // 얼럿 모달
                signoutModal: false,            // 회원탈퇴 모달
                donationReceiptModal: false,    // 기부영수증 모달
                cashReceiptEditModal: false,    // 현금영수증 수정 모달
                createReviewModal: false,       // 후기 작성 모달
                confirmModal: false,            // 컨펌 모달    
                paymentModal: false,            // 결제 정보 입력 모달 
                mournerBankModal: false,        // 조의금 안내 모달     
            },

            modalData: {},
        }
    },

    computed: {
        isAnyModalOpen() {
            return Object.values(this.modals).some((value) => value === true);
        },
    },

    methods: {
        showModal(modalName, options = {}) {
            if (this.modals.hasOwnProperty(modalName)) {
                this.modalData = { ...options };
                this.modals[modalName] = true;
            } else {
                console.warn(`"${modalName}" 모달이 존재하지 않습니다.`);
            }
        },

        closeModal(modalName) {
            if (this.modals.hasOwnProperty(modalName)) {
                this.modals[modalName] = false;
            }
        },

        handleClose(modalName) {
            this.closeModal(modalName);
            this.modalData?.callback?.(false);
        },

        handleConfirm() {
            this.closeModal('confirmModal');
            this.modalData?.callback?.(true);
        },
    },

}
</script>
<style lang="">

</style>